import Quill from 'quill';
import { QuillModule, defaultModules } from 'ngx-quill';
import ImageResize from 'quill-image-resize-module';
//import QuillTableUI from 'quill-table-ui';
import { htmlEditButton } from 'quill-html-edit-button';

// insert imagelink into toolbar
const snowThemeToolbar = Quill.import('themes/snow')?.DEFAULTS?.modules?.toolbar;
if (!!snowThemeToolbar &&
  snowThemeToolbar.handlers['imagelink'] == null
) {
  snowThemeToolbar.handlers['imagelink'] = function imagelink() {
    var range = this.quill.getSelection();
    var value = prompt('please copy paste the image url here.');
    if (!/^http.*/ig.test(value)) {
      value = `https://${value}`;
    }
    if (value) {
      this.quill.insertEmbed(range.index, 'image', value, Quill.sources.USER);
    }
  }
} else {
  console.error('SnowTheme is empty');
}

function customizeToolbarHandler(theme: 'snow' | 'bubble', handlers: { [key: string]: Function }) {
  const themeToolbar = Quill.import(`themes/${theme}`)?.DEFAULTS?.modules?.toolbar;
  if (!!themeToolbar &&
    themeToolbar.handlers != null
  ) {
    for (let [menuName, handler] of Object.entries(handlers)) {
      if (themeToolbar.handlers[menuName] == null) {
        themeToolbar.handlers[menuName] = handler;
      }
    }
    snowThemeToolbar.handlers['imagelink'] = function imagelink() {
      var range = this.quill.getSelection();
      var value = prompt('please copy paste the image url here.');
      if (!/^http.*/ig.test(value)) {
        value = `https://${value}`;
      }
      if (value) {
        this.quill.insertEmbed(range.index, 'image', value, Quill.sources.USER);
      }
    }
  } else {
    console.error('SnowTheme is empty');
  }
}

const customHandlers = {
  imagelink() {
    var range = this.quill.getSelection();
    var value = prompt('please copy paste the image url here.');
    if (!/^http.*/ig.test(value)) {
      value = `https://${value}`;
    }
    if (value && value.trim()?.length > 0) {
      this.quill.insertEmbed(range.index, 'image', value, Quill.sources.USER);
    }
  },
  table() {
    const table = this.quill.getModule('table');
    if (table) {
      table.insertTable(3, 3);
    }
  }
}

customizeToolbarHandler('snow', customHandlers);
customizeToolbarHandler('bubble', customHandlers);


export function ImportQuillModule(importModules?: QuillModule) {
  return QuillModule.forRoot({
    // customModules: [{
    //   implementation: ImageResize,
    //   path: 'modules/imageResize'
    // },
    // {
    //   implementation: QuillTableUI,
    //   path: 'modules/tableUI',
    // },
    // {
    //   implementation: htmlEditButton,
    //   path: 'modules/htmlEditButton'
    // }
    // ],
    // modules: {
    //   ...defaultModules,
    //   imageResize: {},
    //   // table: true,
    //   // tableUI: true,
    //   htmlEditButton: { debug: true, syntax: true, closeOnClickOverlay: false },
    //   ...(importModules || {})
    // }
  });
}